export const apiCreate = (): string => '/commercial/indicationTypes/create'
export const apiList = (id?: string): string =>
  !id
    ? '/commercial/indicationTypes/'
    : `/commercial/indicationTypes/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/indicationTypes/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/indicationTypes/delete/${id}`
